var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddVariable = function SvgAddVariable(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.5 1A2.5 2.5 0 0 0 2 3.5V5.06A1.5 1.5 0 0 1 .974 6.482l-.132.044a.5.5 0 0 0 0 .949l.132.044A1.5 1.5 0 0 1 2 8.942V10.5A2.5 2.5 0 0 0 4.5 13a.5.5 0 1 0 0-1A1.5 1.5 0 0 1 3 10.5V8.942A2.5 2.5 0 0 0 2.075 7 2.5 2.5 0 0 0 3 5.06V3.5A1.5 1.5 0 0 1 4.5 2a.5.5 0 1 0 0-1m5 0A2.5 2.5 0 0 1 12 3.5V5.06a1.5 1.5 0 0 0 1.026 1.423l.132.044a.5.5 0 0 1 0 .949l-.132.044A1.5 1.5 0 0 0 12 8.942V10.5A2.5 2.5 0 0 1 9.5 13a.5.5 0 1 1 0-1 1.5 1.5 0 0 0 1.5-1.5V8.942A2.5 2.5 0 0 1 11.925 7 2.5 2.5 0 0 1 11 5.06V3.5A1.5 1.5 0 0 0 9.5 2a.5.5 0 1 1 0-1M5.146 5.147a.5.5 0 0 1 .708 0L7 6.293l1.146-1.146a.5.5 0 1 1 .708.707L7.707 7l1.147 1.147a.5.5 0 1 1-.708.707L7 7.707 5.854 8.854a.5.5 0 1 1-.708-.707L6.293 7 5.146 5.854a.5.5 0 0 1 0-.707",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddVariable);
export default ForwardRef;